<template>
  <v-dialog v-model="showDialog">
    <v-toolbar dark color="primary" class="mx-auto">
      <v-toolbar-title>
        <span>{{ patientID }} - {{ memName }}</span>
        <span> // {{ provName }} // </span>
        <span>Observation Period - {{ obsPeriod }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="mr-5" color="secondary" outlined dark v-on:click="generateJpeg()">
        <v-icon>mdi-content-save</v-icon>
        <span class="pl-3">Export</span>
      </v-btn>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="capture">
      <v-card tile>
        <v-card-text class="py-3">
          <v-row v-if="this.requestError == true && this.loading != true">
            <v-col>
              <v-alert type="error">Error getting details.</v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ReferenceVsLocalRisk
                :patientID="patientID"
                :insurance="insurance"
                :startDate="startDate"
                :endDate="endDate"
                :groups="groups"
                :providers="providers"
                :locations="locations"
              />
            </v-col>
            <v-col cols="12">
              <DiagnosticSummary
                :patientID="patientID"
                :insurance="insurance"
                :startDate="startDate"
                :endDate="endDate"
                :groups="groups"
                :providers="providers"
                :locations="locations"
              />
            </v-col>
            <v-col cols="12" lg="4">
              <institutionalSummary
                :patientID="patientID"
                :insurance="insurance"
                :startDate="startDate"
                :endDate="endDate"
                :groups="groups"
                :providers="providers"
                :locations="locations"
              />
            </v-col>
            <v-col cols="12" lg="4">
              <ProviderSummary
                :patientID="patientID"
                :insurance="insurance"
                :startDate="startDate"
                :endDate="endDate"
                :groups="groups"
                :providers="providers"
                :locations="locations"
              />
            </v-col>
            <v-col cols="12" lg="4">
              <CmsSummary
                :patientID="patientID"
                :insurance="insurance"
                :startDate="startDate"
                :endDate="endDate"
                :groups="groups"
                :providers="providers"
                :locations="locations"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <AiMarker
                :patientID="patientID"
                :insurance="insurance"
                :startDate="startDate"
                :endDate="endDate"
                :groups="groups"
                :providers="providers"
                :locations="locations"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import * as htmlToImage from 'html-to-image';
import ReferenceVsLocalRisk from './ReferenceVsLocalRisk';
import institutionalSummary from './InstitutionalSummary';
import DiagnosticSummary from './DiagnosticSummary';
import ProviderSummary from './ProviderSummary';
import AiMarker from './AiMarker';
import CmsSummary from './CmsSummary';

export default {
  name: 'AiSubReportModal',
  props: [
    'value',
    'patientID',
    'organizations',
    'insurance',
    'startDate',
    'endDate',
    'providers',
    'groups',
    'locations',
    'memName',
    'provName',
    'obsPeriod',
  ],
  components: {
    ReferenceVsLocalRisk,
    DiagnosticSummary,
    institutionalSummary,
    ProviderSummary,
    AiMarker,
    CmsSummary,
  },
  data() {
    return {
      dialog: false,
      loading: true,
      requestError: false,
    };
  },
  methods: {
    generateJpeg() {
      htmlToImage.toJpeg(document.getElementById('capture'), { quality: 0.95 }).then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'AI_Snapshot' + '.jpeg';
        link.href = dataUrl;
        link.click();
      });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {},
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
